import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SearchableEntityDataService } from './searchable-entity-data.service';
import { ConfirmDialogService } from 'sce-core';
import { AlertService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';


@Injectable()
export class SearchableEntityBackendService {

  protected dataService: SearchableEntityDataService;

  protected http$: HttpClient;
  protected confirmDialogService: ConfirmDialogService;
  public alertService: AlertService;
  protected resourceService: ResourceService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
      this.http$ = coreServiceRegistry.http$;
      this.resourceService = coreServiceRegistry.resourceService;
      this.alertService = sharedServiceRegistry.alertService;
      this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
  }

  public setDependentServices(dataService: SearchableEntityDataService) {
    this.dataService = dataService;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/services/searchable-entity/searchable-entity-backend.service.ts